import { Redirect, Route } from "react-router";
import { getCookie } from "../../utils";

const PrivateRoute = ({ component: Component, location, ...rest }) => (
    <Route {...rest} render={(props) => (
        getCookie('csrf_access_token')
            ? <Component {...props} />
            : <Redirect to={'/logout?from=' + encodeURIComponent(location.pathname)} />
    )} />
);

export { PrivateRoute };